import getTokenTimeLeft from './getTokenTimeLeft'

const isTokenExpired = (accessToken: string | null | undefined): boolean => {
  return getTokenTimeLeft(accessToken) <= 0
}

export default isTokenExpired
